import React, { createContext, useContext } from 'react';
import { useTasks } from '../hooks/useTasks';
import { useAuth } from '../../features/auth/contexts/AuthContext';

const TasksContext = createContext(null);

export function TasksProvider({ children, presetSlug = null, listIdFromUrl = null, fromSidebarNavigation = false }) {
  const { isLoggedIn, isLoading } = useAuth();
  const tasksData = useTasks(isLoggedIn, isLoading, presetSlug, listIdFromUrl, fromSidebarNavigation);
  return (
    <TasksContext.Provider value={tasksData}>
      {children}
    </TasksContext.Provider>
  );
}

export function useTasksContext() {
  const context = useContext(TasksContext);
  if (!context) {
    throw new Error('useTasksContext must be used within a TasksProvider');
  }
  return context;
}

